import { XIcon } from 'lucide-react';
import { Button } from '../button';
import { useFiltersContext } from './filters-context';

export interface FiltersClearProps {
  /** Keys to consider when deciding whether to show the button. */
  watchKeys: string[];
  children?: React.ReactNode;
}

/** Clears all managed filters. Hidden when no managed filter is active. */
export function FiltersClear({ watchKeys, children = 'Clear' }: FiltersClearProps) {
  const { hasAny, clearAll } = useFiltersContext();
  if (!hasAny(watchKeys)) return null;
  return (
    <Button variant="ghost" size="sm" onClick={clearAll}>
      <XIcon />
      {children}
    </Button>
  );
}
